module.exports = __webpack_public_path__ + "img/D2.6127a481.png";